import API from '../api/config/apiUrls.ts'

import { defineStore } from 'pinia'
import { useApi } from '@/api/config/useApi'
import { useShipApi } from '@/api/config/useShipApi.ts'
import { useShipApiStore } from './shipApi.js'
import { useSpeckleAuthStore } from '@haskoning/vue-speckle'

const { api } = useApi()
const { api: shipApi } = useShipApi()

export const useDjangoAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
  }),
  actions: {
    async authenticateShipApi() {
      const url = 'ships/mlgships_authorization'
      const shipApiStore = useShipApiStore()
      try {
        const response = await api.service(url).get()
        if (!response) {
          shipApiStore.isAuth = false
          return 
        }
        const accessToken = response.access
        const refreshToken = response.refresh
        if (accessToken && refreshToken) {
          localStorage.setItem('accessShipApi', accessToken)
          localStorage.setItem('refreshShipApi', refreshToken)
          await shipApi.apiService.authenticationHandler.setAccessTokenInHeaderFromStore().then()
          shipApiStore.isAuth = true
        } else {
          shipApiStore.isAuth = false
        }
      } catch (e) {
        shipApiStore.isAuth = false
        console.log(e)
      }
    },
    async authenticate({ email, password }: { email: string; password: string }) {
      await api.apiService.authenticationHandler.authenticate(email, password)
      const userResponse = await api.service(API.CORE.USERS.CURRENT_USER).get()
      return { user: userResponse }
    },
    async reAuthenticate() {
      await api.apiService.authenticationHandler.reauthenticate()
      try {
        const userResponse = await api.service(API.CORE.USERS.CURRENT_USER).get()
        return { user: userResponse }
      } catch (e) {
        return { user: null }
      }
    },
    async getPromise() {},
    async logout() {
      localStorage.removeItem('access')
      localStorage.removeItem('refresh')
      localStorage.removeItem('accessShipApi')
      localStorage.removeItem('refreshShipApi')

      const speckleAuthStore = useSpeckleAuthStore()
      speckleAuthStore.disconnect()
      this.user = null
    }
  }
})
